module.exports = __webpack_public_path__ + "img/jo-vasquez.4e12d779.webp";